<div class="mb-8 text-center text-h4 font-medium text-text-secondary">{{ 'site_install_confirmation_title' | translate }}</div>

<div class="mb-4 flex items-center justify-between">
  <h5 class="typo-h5-semibold-5p">{{ 'site_install_confirmation_practice_name' | translate }}</h5>
  <p class="typo-h5-book text-text-secondary">{{ dialogData.practiceName }}</p>
</div>

<hr class="mb-4 text-background-disabled" />

<div class="mb-4 flex items-center justify-between">
  <h5 class="typo-h5-semibold-5p">{{ 'site_install_confirmation_address' | translate }}</h5>
  <p class="typo-h5-book max-w-[50%] text-right text-text-secondary">{{ dialogData.address }}</p>
</div>

<hr class="mb-4 text-background-disabled" />

<div class="mb-4 flex items-center justify-between">
  <h5 class="typo-h5-semibold-5p">{{ 'site_install_confirmation_name_of_the_signer' | translate }}</h5>
  <p class="typo-h5-book text-text-secondary">{{ dialogData.signerName }}</p>
</div>

<hr class="mb-4 text-background-disabled" />

<div class="flex justify-between gap-4">
  <button class="btn-secondary w-full justify-center" (click)="onBackClick()">
    {{ 'site_install_confirmation_back_to_edit' | translate }}
  </button>
  <button class="btn-primary w-full justify-center" (click)="onConfirmClick()">
    {{ 'site_install_confirmation_confirm_and_submit' | translate }}
  </button>
</div>
